export  default {
  setUserState(state, payload) {
    state.userState = payload;
  },
  setResponseCode(state, payload) {
    state.responseCode = payload;
  }
};